import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/src/features/premium-subscribe/ui/SubscribeForm/SubscribeForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
